import { action, observable } from 'mobx';
import { CompanySettingDto } from '../models/dtos/company';

export class CompanyStore {
  @observable
  companySetting: CompanySettingDto | null = null;

  @observable
  isLoading = false;

  @action
  setCompanySetting(setting: CompanySettingDto) {
    this.companySetting = setting;
  }

  @action
  setLoading(value: boolean) {
    this.isLoading = value;
  }

  @action
  reset() {
    this.companySetting = null;
    this.isLoading = false;
  }

  get hasCompanySetting(): boolean {
    return this.companySetting !== null;
  }

  get loanPartnerId(): number | null {
    return this.companySetting?.loanPartnerId ?? null;
  }

  get marketingSpiel(): string {
    return this.companySetting?.marketingSpiel ?? '';
  }

  get marketingSpielNote(): string {
    return this.companySetting?.marketingSpielNote ?? '';
  }
}
